import { BackArrow, SaveIcon } from "allIcons";
import {
  useAddGlossaryCategory,
  useDeleteGlossaryCategory,
  useGetGlossaryCategory,
  useGlosssary,
  useUpdateGlossaryCategory,
} from "api/templateLibrary/glossary";
import {
  BodyContainer,
  DeleteButton,
  HeaderContainer,
  IconWrapper,
  InputField,
  Loader,
  MainButton,
  PrimaryHeading,
  RightMainContainer,
} from "commonUI";
import { ModulePrefixes, NotificationType } from "enums";
import { getUserSavePermission, isEqual, useUtilities } from "helpers";
import { useUserPermissions } from "hooks/user";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function AddEditGlossaryCategory() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { mutate: addCategory, isLoading: addingCategory } =
    useAddGlossaryCategory();
  const { mutate: updateCategory, isLoading: updatingCategory } =
    useUpdateGlossaryCategory();
  const { notification } = useUtilities();
  const { add_new_templates, edit_templates, delete_templates } =
    useUserPermissions();
  const { mutate: deleteCategory, isLoading: deletingCategory } =
    useDeleteGlossaryCategory();
  const { data: categories, isLoading: loadingCategoryies } =
    useGetGlossaryCategory();
  const { data: glossary } = useGlosssary();

  const [title, setTitle] = useState("");

  useEffect(() => {
    if (!categories || loadingCategoryies || isEqual(id, "add")) return;
    const categoryData = categories.find((ele) => isEqual(ele.id, id));
    if (categoryData) {
      setTitle(categoryData.title);
    }
  }, [id, loadingCategoryies, categories]);

  const handleSaveChanges = () => {
    if (!title.trim()) {
      notification({
        type: NotificationType.ERROR,
        message: t("common.input.error.titleRequired"),
      });
      return;
    }
    if (isEqual(id, "add")) {
      addCategory(title);
    } else {
      updateCategory({
        title,
        category_id: id,
      });
    }
  };

  return (
    <>
      <RightMainContainer>
        <Loader
          loader="block"
          show={deletingCategory || addingCategory || updatingCategory}
        />
        <HeaderContainer>
          <IconWrapper>
            <BackArrow
              onClick={() => navigate(`/${ModulePrefixes.TEMPLATE_LIBRARY}/glossary/categories`)}
            />
            <PrimaryHeading>
              {isEqual(id, "add")
                ? t("libraryTemplate.glossaryCategories.addCategory")
                : title}
            </PrimaryHeading>
          </IconWrapper>
          <div className="flex items-center justify-center gap-14">
            <DeleteButton
              show={!isEqual(id, "add") && delete_templates}
              onDelete={() => {
                if (glossary?.some((_) => isEqual(_.category_id, id))) {
                  notification({
                    type: NotificationType.ERROR,
                    message: t(
                      "libraryTemplate.glossaryCategories.delete.failed.message"
                    ),
                  });
                  return;
                }
                deleteCategory(id);
              }}
              deleteTitle={t("libraryTemplate.delete.title")}
              deleteButtonText={t("libraryTemplate.delete.button")}
              deleteMessage={t("libraryTemplate.delete.message")}
            />
            {getUserSavePermission({
              id,
              addPermission: add_new_templates,
              editPermission: edit_templates,
            }) ? (
              <MainButton onClick={handleSaveChanges}>
                <SaveIcon />
                {t("button.saveChanges")}
              </MainButton>
            ) : (
              ""
            )}
          </div>
        </HeaderContainer>
        <BodyContainer>
          <InputField
            label={t("common.input.title.label")}
            placeholder={t("common.input.title.placeholder")}
            value={title}
            setValue={(value) => setTitle(value)}
          />
        </BodyContainer>
      </RightMainContainer>
    </>
  );
}
